<template>
	<div class="box">
		<div class="null-page" v-show="yes"></div>
		<el-card class="box-card order-list">
			<div slot="header" class="clearfix"><span>品牌授权信息</span></div>
			
			<div class="notice-info">
				<div class="content-container" style="height: 1250px;" ref="contentToConvert">
					<div class="contract-container" id="contract-container">
						<div  class="title">授 权 书</div>
						<div  class="top-info">
							<div  class="info-item">
								<span class="key">授权公司:</span>
								<span class="value">{{info.sqf_name}}</span>
							</div>
							<div class="info-item">
								<span class="key">被授权公司:</span>
								<span class="value">{{info.bsqf_name}}</span>
							</div>
						</div>
						<div class="content">
							<div  class="content-item"> 兹授权<span>{{info.bsqf_name}}</span>作为我公司在<span>京东慧采</span>项目中销售<span>{{info.brand_name}}</span>品牌的产品。 </div>
							<div class="content-item"> 授权方确保确保授权的真实性，同时具备给被授权方销售权利，被授权方需严格按照授权书规定的区域范围和要求进行销售。被授权方因违法违规或违反授权书内容要求而导致的纠纷投诉等法律责任和赔偿责任均由被授权方独立承担，并赔偿由此给授权方及品牌造成的直接和间接损失。 </div>
							<div class="content-item"> 被授权方不具有再授权权利，不得许可任何第三人享有授权方授予的权利。 </div>
							<div class="content-item"> 为保证正品，本授权仅在被授权公司向授权公司采购上述项目所有商品情况下生效，自授权开具之日起叁个月内未向授权方采购上述授权商品视为该授权自动失效。 </div>
							<div class="content-item"> 本授权为可撤销的授权文件，授权方有权随时终止本授权。 </div>
							<div class="content-item"> 授权时间：即日起至<span>{{ $util.timeStampTurnTimeday(info.end_time) }}</span></div>
						</div>
						<div class="bottom" style="overflow: hidden;">
							<div style="width: 100%; overflow: hidden;">
								<div class="bottom-info" style="width: 320px; float: right;">
									<span class="key">授权公司：</span>
									<span class="value" >{{info.sqf_name}}</span>
								</div>
							</div>
							<div style="width: 100%; overflow: hidden;">
								<div class="time">
									<div class="bottom-info" style="width: 420px; float: right;">
										<span class="key" >签 &nbsp; 章：</span>
										<span class="value" style="float: right; margin-right: 30px; padding-top: 30px;">{{ $util.timeStampTurnTimeday(info.sq_time) }}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="logo">
							<img src="../../assets/images/gzinfo.png" alt="" crossorigin="anonymous">
						</div>
					</div>
				</div>
			</div>
			<div class="dialog-footer">
				<div class="btn cancel">返回</div>
				<div class="btn submit" @click="generatePDF">下载授权书</div>
			 </div>
		</el-card>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { authorDetail, save, uploadImg } from '@/api/order/order';
import Config from '@/utils/config';

export default {
	name: 'author',
	components: {},
	data: () => {
		return {
			loading: true,
			filename: '授权文件.pdf',
			info:[],
			collect_id: 0,
			hide: []
		};
	},
	created() {
		this.collect_id = this.$route.query.collect_id;
		this.getDetail();
		if (this.collect_id) {
			this.getDetail();
		}
	},
	computed: {
		...mapGetters(['defaultGoodsImage'])
	},
	methods: {
		async generatePDF() {
		  const element = this.$refs.contentToConvert;
		  console.log(element)
		  const canvas = await html2canvas(element);
		  const imgData = canvas.toDataURL('image/png');
		  const pdf = new jsPDF('p', 'mm', 'a4');
		  const imgProps = pdf.getImageProperties(imgData);
		  const pdfWidth = pdf.internal.pageSize.getWidth();
		  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
		  
		  pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
		  pdf.save(this.filename); // 保存PDF文件
		},
		getDetail() {
			authorDetail({
				collect_id: this.collect_id
			})
			.then(res => {
				if (res.data) {
					this.info = res.data;
					this.filename = res.data.sqf_name+'授权文件.pdf';
					this.loading = false;
				} else {
					this.$router.push({ path: '/notice' });
				}
			})
			.catch(err => {
				this.loading = false;
				this.$message.error(err.message);
			});
		}
	}
};
</script>
<style lang="scss" scoped>

.auth-container{width:100%;box-sizing:border-box;border-radius:6px;min-height:600px;position:relative;margin-bottom:40px}
.auth-container .header{width:100%;background-color:#f8f9f9}
.auth-container .tabs-class .el-tabs__header .is-active{color:#202230}
.auth-container .tabs-class .el-tabs__header .el-tabs__item{color:#202230;font-weight:700}
.auth-container .tabs-class  .el-tabs__header .el-tabs__active-bar{background-color:#e7390c}
.content-container{width:900px;background-image:url(../../assets/images/auth-bg-r56UnsRj.png);background-size:100% 100%;box-sizing:border-box;padding:80px}
.content-container .contract-container{width:100%;position:relative;padding-bottom:30px;box-sizing:border-box;background:transparent}
.content-container .contract-container .title{font-size:20px;font-weight:700;text-align:center;margin-bottom:60px}
.content-container .contract-container .top-info{width:100%;margin-bottom:40px}
.content-container .contract-container .top-info .info-item{width:100%;margin-bottom:14px; font-size:17px;}
.content-container .contract-container .top-info .info-item .key{margin-right:14px}
.content-container .contract-container .top-info .info-item .value{display:inline-block;min-width:100px;line-height:1.5;border-bottom:1px solid #000}
.content-container .contract-container .content{width:100%; font-size:17px;}
.content-container .contract-container .content .content-item{width:100%;line-height:1.9;margin-bottom:8px;text-indent:2em}
.content-container .contract-container .content .content-item span{padding:0 8px;margin:0 4px;box-sizing:border-box;display:inline;min-width:100px;border-bottom:1px solid #000}
.content-container .contract-container .bottom{width:100%;text-align:left;position:relative;margin-top:50px;z-index:9}
.content-container .contract-container .bottom .bottom-info{width:100%;margin-bottom:30px; font-size:17px;}
.content-container .contract-container .bottom .bottom-info .value{text-decoration:underline}
.content-container .contract-container .bottom .sign{position:absolute;right:320px;top:24px}
.content-container .contract-container .logo{position:absolute;right:50px;bottom:0}
.content-container .contract-container .logo img{width:200px;display:block}
.no-auth{width:100%;text-align:center;font-size:18px;color:#999;margin-top:100px}
.dialog-footer{width:100%;margin-top:20px;display:flex;align-items:center;justify-content:center}
.dialog-footer .btn{width:120px;height:40px;border-radius:6px;font-size:15px;color:#666;display:flex;align-items:center;justify-content:center;cursor:pointer}
.dialog-footer .cancel{border:1px solid #E2E2E2;margin-right:20px}
.dialog-footer .submit{background:#e7390c;color:#fff;margin-right:20px}
</style>
<style lang="scss">
.ns-evalute {
	.el-upload--picture-card,
	.el-upload-list--picture-card .el-upload-list__item {
		width: 70px;
		height: 70px;
		line-height: 80px;
		position: relative;
	}
	.el-upload-list--picture-card .el-upload-list__item-thumbnail {
		width: 100%;
		height: auto;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
	}
	.el-upload-list__item.is-success .el-upload-list__item-status-label {
		display: none;
	}
	.ishide .el-upload--picture-card {
		display: none;
	}
	.el-dialog {
		.el-dialog__body {
			text-align: center;
		}
	}
}
</style>
